<template>
    <div class="my-habits-chart-progress"
         :style="containerStyle">

        <highcharts :options="chartOptions"></highcharts>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

    import Vue from 'vue'
    import moment from 'moment'
    import * as _ from 'lodash'

    /**
     * Component to display progress chart for a wellness Habit
     */
    export default Vue.extend({
        props: {
            size: String, // 'sm' or 'lg'
            habit: Object
        },
        computed: {
            chartOptions () {
                const options = this.getBaseOptions()
                if (this.habit) {
                    this.addHabitOptions(options)
                }
                return options
            },
            containerStyle () {
                if (this.size == 'lg') {
                    return {
                        width: '100%'
                    }
                } else {
                    return {
                        width: '80px'
                    }
                }
            }
        },
        methods: {
            getBaseOptions () {
                const PROGRESS = this.$i18n.gt('LABEL_MY_HABITS_PROGRESS')
                return {
                    chart: {
                        borderColor: '#fff',
                        borderWidth: 4,
                        type: 'line',
                        height: this.size == 'lg' ? '50%' : '100%',
                        showAxes: false,
                        backgroundColor: '#eee',
                        plotBackgroundColor: '#eee',
                        margin: (this.size == 'lg' ? 40 : 10),
                    },
                    title: null,
                    credits: { enabled: false },
                    tooltip: { enabled: this.size == 'lg' },
                    legend: { enabled: false },

                    plotOptions: {
                        series: {
                            color: `rgb(128, 128, 128, 1)`,
                            marker: {
                                symbol: 'circle',
                                radius: (this.size == 'lg' ? 12 : 4),
                            },
                            tooltip: {
                                pointFormatter: function () {
                                    return `${PROGRESS}: ${this.y}/10`
                                }
                            },
                        }
                    },

                    xAxis: {
                        visible: false,
                        type: 'datetime',
                        tickAmount: 2,
                        title: null,
                    },

                    yAxis: {
                        gridLineWidth: 0,
                        max: 10,
                        min: 1,
                        tickPositions: [1, 10],
                        title: null,
                    },

                    series: [{
                        data: []
                    }]
                }
            },
            addHabitOptions (options) {
                options.series[0].data = _.map(this.habit.progressEntries, (entry) => {
                    return [
                        moment(entry.timestamp).format('M/D/YYYY'),
                        entry.progress
                    ]
                })
            }
        }
    })

</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
    .my-habits-chart-progress {
    }
</style>
